import { useCallback, useEffect, useState } from 'react';

import { CookiesModal } from '@/components/modals/CookiesModal';
import { useGetCommonStore } from '@/store';

export const STORAGE_COOKIES_KEY = 'accept-cookies';

export const useCookiesModal = () => {
  const useCommonStore = useGetCommonStore();

  const countryCode = useCommonStore.use.countryCode();

  const cookiesKey =
    typeof window === 'undefined'
      ? 'unknown'
      : localStorage.getItem(STORAGE_COOKIES_KEY);

  const [isOpenCookieModal, setIsOpenCookieModal] = useState(false);

  useEffect(() => {
    setIsOpenCookieModal(!cookiesKey);
  }, [countryCode, cookiesKey]);

  const handleAcceptCookie = useCallback(() => {
    localStorage.setItem(STORAGE_COOKIES_KEY, 'true');
    setIsOpenCookieModal(false);
  }, [setIsOpenCookieModal]);

  return isOpenCookieModal ? (
    <CookiesModal onClose={handleAcceptCookie} />
  ) : null;
};
